import state from './modulePortMasterState.js'
import mutations from './modulePortMasterMutations.js'
import actions from './modulePortMasterActions.js'
import getters from './modulePortMasterGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}